/* esm.sh - @radix-ui/react-accessible-icon@1.1.8 */
export * from "/*@radix-ui/react-accessible-icon@1.1.8/esnext/react-accessible-icon.mjs";
